import 'css-chunksrc/feature/check-item-detail/CheckItemDetailSeatPosition.module.scss';export default {
  "root": "CheckItemDetailSeatPosition_root",
  "headingRoot": "CheckItemDetailSeatPosition_headingRoot",
  "headingText": "CheckItemDetailSeatPosition_headingText",
  "optionsContainer": "CheckItemDetailSeatPosition_optionsContainer",
  "btn": "CheckItemDetailSeatPosition_btn",
  "pulse": "CheckItemDetailSeatPosition_pulse",
  "selected": "CheckItemDetailSeatPosition_selected",
  "label": "CheckItemDetailSeatPosition_label",
  "tableBtn": "CheckItemDetailSeatPosition_tableBtn",
  "seatBtn": "CheckItemDetailSeatPosition_seatBtn",
  "seatBtnLabel": "CheckItemDetailSeatPosition_seatBtnLabel",
  "seatBtnIcon": "CheckItemDetailSeatPosition_seatBtnIcon"
};